import { render, staticRenderFns } from "./RelatieUnitsOverzicht.vue?vue&type=template&id=d2e571de"
import script from "./RelatieUnitsOverzicht.vue?vue&type=script&lang=js"
export * from "./RelatieUnitsOverzicht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports